export class Message {
    public messages: { message: string; added: boolean }[]
    public wrapper: string

    constructor(
        public type: string,
        public title: string,
        message: string,
        public duration: number,
    ) {
        this.messages = [{ message: message, added: false }]
        this.wrapper = '<span class="message-line" />'
    }

    addMessage(message: string) {
        this.messages.unshift({ message: message, added: false })
    }

    message() {
        const notShownMessages: string[] = []
        let index: number

        for (index = 0; index < this.messages.length; ++index) {
            if (true === this.messages[index].added) {
                continue
            }

            this.messages[index].added = true
            notShownMessages.unshift(
                $(this.wrapper)
                    .prop("id", `${this.type}-line-${this.messages.length - index}`)
                    .html(this.messages[index].message)
                    .prop("outerHTML"),
            )
        }

        return notShownMessages.join("\n")
    }

    messageList() {
        return this.messages.slice(0)
    }
}
